import axios, { AxiosError } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { GET_SEARCH_FILTER_STRUCTURE, DOMAIN_NAME } from '@/constants';
import { SearchFilterStructureRo } from '@/types';

const fetchSearchFilters = (): Promise<SearchFilterStructureRo> => {
  const url = `${GET_SEARCH_FILTER_STRUCTURE}/${DOMAIN_NAME}`;
  console.log('[useGetSearchFilters] GET', url);
  return axios.get<SearchFilterStructureRo>(url).then((res) => {
    console.log('[useGetSearchFilters] status', res.status);
    return res.data;
  });
};

export const SEARCH_FILTERS_QUERY_KEY = ['search-filters'];

export const useGetSearchFilters = () =>
  useQuery<SearchFilterStructureRo, AxiosError>({
    queryKey: SEARCH_FILTERS_QUERY_KEY,
    queryFn: fetchSearchFilters,
    staleTime: Infinity,
    retry: false,
  });
